import { allTrackers } from "app/services/track/track";
import createIntentTrackingService from "./factory";

const intentTrackingService = createIntentTrackingService(allTrackers.dispatchTrackEvent.bind(allTrackers));

export default intentTrackingService;
